import MyButton from './MyButton';
import useWindowSize from '../../hooks/useWindowSize';

const MyButtonSecondary = ({
  icon,
  label,
  forceLabelIcon = false,
  ...otherProps
}) => {
  const { isMobile } = useWindowSize();

  const labelCondition = forceLabelIcon || !isMobile || !icon;

  return (
    <MyButton
      {...otherProps}
      icon={icon}
      label={labelCondition ? label : null}
      type="primary"
      variant="outlined"
      ghost
    />
  );
};

export default MyButtonSecondary;
